import { GET_SPONSORSHIP_BY_TEACHR, UPDATE_SPONSORSHIP_BY_TEACHR } from "../Actions/SponsorshipActions";

const initialState: any = {
  sponsorship: [],
  sponsorUpdate : null
};

export default function sponsorshipReducers(state = initialState, action: any) {
  switch (action.type) {
    case GET_SPONSORSHIP_BY_TEACHR:
      return { ...state, sponsorship: action.payload };
    case UPDATE_SPONSORSHIP_BY_TEACHR:
      return { ...state, sponsorUpdate: action.payload };

    default:
      return state;
  }
}
